module.exports = __webpack_public_path__ + "img/loginBg.678a6bdf.png";